import { render, staticRenderFns } from "./PortalNavMenu.vue?vue&type=template&id=26f0c4dc"
import script from "./PortalNavMenu.vue?vue&type=script&lang=js"
export * from "./PortalNavMenu.vue?vue&type=script&lang=js"
import style0 from "./PortalNavMenu.vue?vue&type=style&index=0&id=26f0c4dc&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4268610792/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26f0c4dc')) {
      api.createRecord('26f0c4dc', component.options)
    } else {
      api.reload('26f0c4dc', component.options)
    }
    module.hot.accept("./PortalNavMenu.vue?vue&type=template&id=26f0c4dc", function () {
      api.rerender('26f0c4dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/PortalNavMenu.vue"
export default component.exports